import {TtWorkingTimeEntry} from '../interfaces/time-tracking/tt-working-time-entry';
import {Query} from '../services/core/query';
import {TtWorkingTimeEntryFactory} from '../factories/time-tracking/tt-working-time-entry-factory';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TtWorkingTimeEntriesResource extends Query<TtWorkingTimeEntry, {
  dateFrom?: string,
  dateTo?: string,
  employeeId?: number
}> {
  constructor() {
    super('tt-working-time-entries', TtWorkingTimeEntryFactory.fromArray);
  }
}
